import {
    DETAILS_TRANSACTIONS_TOKU,
    DETAILS_TRANSACTIONS_TOKU_ERROR,
    CLEAN_DETAILS_TRANSACTIONS_TOKU,
    CLEAN_DETAILS_TRANSACTIONS_TOKU_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    response: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case DETAILS_TRANSACTIONS_TOKU:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                response: action?.response || {},
                status: action?.status || null,
                state: "success",
            };

        case DETAILS_TRANSACTIONS_TOKU_ERROR:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                response: action?.response || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_DETAILS_TRANSACTIONS_TOKU:
            return {
                ...state,
                loaded: false,
                method: undefined,
                response: action?.response || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_DETAILS_TRANSACTIONS_TOKU_ERROR:
            return {
                ...state,
                loaded: false,
                method: undefined,
                response: action?.response || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
